module.exports = __webpack_public_path__ + "static/media/125.4a08cb58.svg";